import React, { useEffect, useState } from "react"
import { recursiveAPI } from "services";
import useUniversalStore from "store/universalStore";
import EachRtxn from "./EachRtxn";
import useOffcanvasStore from "store/offcanvasStore";

const RecursivetxnsView = () => {

    const accountId = useUniversalStore((state) => state.accountId);
    const { openOffcanvas } = useOffcanvasStore();
    const [txns, setTxns] = useState([]);
    const [loading, setLoading] = useState(false);

    const refreshTxns = async () => {
        try {
            setLoading(true);
            const result = await recursiveAPI.fetchRecursiveTxns(accountId);
            setTxns(result);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        refreshTxns();
    }, [accountId]);

    if (loading) {
        return (
            <div className="row h-100 align-items-center justify-content-center fw-bold flex-column">
                <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            {txns?.length != 0 ?
                <>
                    <div className="row">
                        <br />
                        {txns?.map((txn, index) => <EachRtxn txn={txn} key={txn.id} triggertxns={refreshTxns} />)}
                    </div>
                </> :
                <div className="row h-100 align-items-center justify-content-center fw-bold flex-column">
                    <button className="btn text-app" onClick={() => openOffcanvas("newTxn", { Txntype: "recurring" })}>
                        <div className="bi bi-database-add fs-1 text-center w-100"></div>
                        <div className="text-center w-100">Add a recurring txn!</div>
                    </button>
                </div>
            }
        </>
    )
};

export default RecursivetxnsView;
